// export const API_BASE_URL = "http://localhost:9000/api/v1/";
// export const API_BASE_URL = "https://crowdfundingapi.iosx.in/api/v1/";
export const API_BASE_URL = "https://api.cabbooking.iosx.in/api/v1";
export const SOCKET_URL = "https://api.cabbooking.iosx.in/";
// export const API_BASE_URL = "https://api.rydegrand.com/api/v1";
